import { Type as T } from '@sinclair/typebox';
import { Value } from '@sinclair/typebox/value';
import { validateField } from '../index.js';

export const DefinePasswordSchema = T.Object({
  email: T.String({ minLength: 1, maxLength: 80, error: 'Identificador inválido' }),
  code: T.String({ minLength: 6, maxLength: 6, error: 'Código de verificação inválido' }),
  password: T.String({
    minLength: 8,
    maxLength: 80,
    error: 'A senha precisa conter ao menos 8 caracteres, um caractere especial, um maiúsculo e um numérico',
    format: 'password',
  }),
  // Tenant slug for multi-tenant user lookup (required to avoid cross-tenant conflicts)
  tenantSlug: T.Optional(T.String({ minLength: 1, maxLength: 50 })),
});

export type DefinePasswordInputType = typeof DefinePasswordSchema.static;

export async function ValidateDefinePasswordValidateInput(value: unknown): Promise<DefinePasswordInputType> {
  return Value.Parse(DefinePasswordSchema, value);
}

export function checkDefinePasswordInput(field: string, value: unknown): string | boolean {
  const baseValidation = validateField(DefinePasswordSchema, field, value);

  if (baseValidation !== true) {
    return baseValidation;
  }

  // Se o valor parece ser um email, validar formato de email
  if (field === 'email' && typeof value === 'string' && value.includes('@')) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      return 'Formato de e-mail inválido';
    }
  }

  return true;
}
